import React, { useEffect } from "react"
import "../styles/App.scss"
import Chart from "chart.js"

let myChart

const BarChart = ({ value, range }) => {
  let data = []
  let rangeCounter = 0
  let rangeLimit = 9

  if (value[0] !== undefined) data = value

  //Actualiza los rangos basado en la opción seleccionada
  switch (range) {
    case "Semana 26-36":
      rangeCounter = 0
      rangeLimit = 9
      break
    case "Semana 37-47":
      rangeCounter = 10
      rangeLimit = 20
      break
    case "Semana 48-58":
      rangeCounter = 21
      rangeLimit = 31
      break
    case "Semana 59-69":
      rangeCounter = 32
      rangeLimit = 42
      break
    case "Semana 70-80":
      rangeCounter = 43
      rangeLimit = 53
      break
    case "Semana 81-91":
      rangeCounter = 54
      rangeLimit = 64
      break
    case "Semana 92-102":
      rangeCounter = 65
      rangeLimit = 75
      break
    case "Semana 103-113":
      rangeCounter = 76
      rangeLimit = 86
      break
    default:
      rangeCounter = 0
      rangeLimit = 9
      break
  }

  //Arreglos para valores de cada categoría
  let registroImss = [],
    verificacionMedica = [],
    equipoProteccion = [],
    certificados = [],
    calidad = [],
    usoAdecuado = [],
    mantenimiento = [],
    limpiezaOrden = [],
    senaletica = [],
    procesosConstructivos = []

  for (let i = rangeCounter; i < rangeLimit; i++) {
    registroImss.push(data[i] !== undefined ? data[i][0] : 0)
    verificacionMedica.push(data[i] !== undefined ? data[i][1] : 0)
    equipoProteccion.push(data[i] !== undefined ? data[i][2] : 0)
    certificados.push(data[i] !== undefined ? data[i][3] : 0)
    calidad.push(data[i] !== undefined ? data[i][4] : 0)
    usoAdecuado.push(data[i] !== undefined ? data[i][5] : 0)
    mantenimiento.push(data[i] !== undefined ? data[i][6] : 0)
    limpiezaOrden.push(data[i] !== undefined ? data[i][7] : 0)
    senaletica.push(data[i] !== undefined ? data[i][8] : 0)
    procesosConstructivos.push(data[i] !== undefined ? data[i][9] : 0)
  }

  useEffect(() => {
    let ctx = document.getElementById("barchart")
    ctx.height = window.innerWidth < 768 ? 340 : 240
    ctx.width = window.innerWidth < 768 ? 340 : 310

    if (typeof myChart !== "undefined") myChart.destroy()

    let labels = [""]
    switch (range) {
      case "Semana 26-36":
        labels = [
          "Sem 26",
          "Sem 27",
          "Sem 28",
          "Sem 29",
          "Sem 30",
          "Sem 31",
          "Sem 32",
          "Sem 33",
          "Sem 34",
          "Sem 35",
          "Sem 36",
        ]
        break
      case "Semana 37-47":
        labels = [
          "Sem 37",
          "Sem 38",
          "Sem 39",
          "Sem 40",
          "Sem 41",
          "Sem 42",
          "Sem 43",
          "Sem 44",
          "Sem 45",
          "Sem 46",
          "Sem 47",
        ]
        break
      case "Semana 48-58":
        labels = [
          "Sem 48",
          "Sem 49",
          "Sem 50",
          "Sem 51",
          "Sem 52",
          "Sem 53",
          "Sem 54",
          "Sem 55",
          "Sem 56",
          "Sem 57",
          "Sem 58",
        ]
        break
      case "Semana 59-69":
        labels = [
          "Sem 59",
          "Sem 60",
          "Sem 61",
          "Sem 62",
          "Sem 63",
          "Sem 64",
          "Sem 65",
          "Sem 66",
          "Sem 67",
          "Sem 68",
          "Sem 69",
        ]
        break
      case "Semana 70-80":
        labels = [
          "Sem 70",
          "Sem 71",
          "Sem 72",
          "Sem 73",
          "Sem 74",
          "Sem 75",
          "Sem 76",
          "Sem 77",
          "Sem 78",
          "Sem 79",
          "Sem 80",
        ]
        break
      case "Semana 81-91":
        labels = [
          "Sem 81",
          "Sem 82",
          "Sem 83",
          "Sem 84",
          "Sem 85",
          "Sem 86",
          "Sem 87",
          "Sem 88",
          "Sem 89",
          "Sem 90",
          "Sem 91",
        ]
        break
      case "Semana 92-102":
        labels = [
          "Sem 92",
          "Sem 93",
          "Sem 94",
          "Sem 95",
          "Sem 96",
          "Sem 97",
          "Sem 98",
          "Sem 99",
          "Sem 100",
          "Sem 101",
          "Sem 102",
        ]
        break
      case "Semana 103-113":
        labels = [
          "Sem 103",
          "Sem 104",
          "Sem 105",
          "Sem 106",
          "Sem 107",
          "Sem 108",
          "Sem 109",
          "Sem 110",
          "Sem 111",
          "Sem 112",
          "Sem 113",
        ]
        break
      default:
        labels = [
          "Sem 26",
          "Sem 27",
          "Sem 28",
          "Sem 29",
          "Sem 30",
          "Sem 31",
          "Sem 32",
          "Sem 33",
          "Sem 34",
          "Sem 35",
          "Sem 36",
        ]
        break
    }

    myChart = new Chart(ctx, {
      type: "bar",
      data: {
        labels: labels,

        datasets: [
          {
            label: "Registro de personal de IMSS",
            data: registroImss,
            backgroundColor: "#1d4e89",
          },
          {
            label: "Verificación médica incluido COVID",
            data: verificacionMedica,
            backgroundColor: "#1c558e",
          },
          {
            label: "Equipo de protección personal",
            data: equipoProteccion,
            backgroundColor: "#1a5b92",
          },
          {
            label: "Certificados DC3 en actividades",
            data: certificados,
            backgroundColor: "#16679a",
          },
          {
            label: "Calidad de la maquinaría y herramienta",
            data: calidad,
            backgroundColor: "#0f80aa",
          },
          {
            label: "Uso adecuado",
            data: usoAdecuado,
            backgroundColor: "#0899ba",
          },
          {
            label: "Mantenimiento",
            data: mantenimiento,
            backgroundColor: "#04a6c2",
          },
          {
            label: "Limpieza y Orden",
            data: limpiezaOrden,
            backgroundColor: "#00b2ca",
          },
          {
            label: "Señaletica",
            data: senaletica,
            backgroundColor: "#20bac5",
          },
          {
            label: "Procesos Constructivos",
            data: procesosConstructivos,
            backgroundColor: "#3fc1c0",
          },
        ],
      },
      options: {
        legend: {
          position: "bottom",
          align: "center",
          labels: {
            fontSize: 12,
            fontColor: "black",
            fontFamily: "Arial, sans-serif",
          },
        },
        fill: false,
        responsive: true,
        scales: {
          xAxes: [
            {
              stacked: true,
            },
          ],
          yAxes: [
            {
              stacked: true,
              display: false,
            },
          ],
        },
      },
    })
  }, [myChart])

  return (
    <>
      <div className="elements">
        <div className="chart-container-bars">
          <canvas id="barchart"></canvas>
        </div>
      </div>
    </>
  )
}

export default BarChart
